module.exports = __webpack_public_path__ + "img/40_01_010_077.1102e608.jpg";